import { applyMiddleware, createStore } from 'redux';
import {taskMiddleware} from 'react-palm/tasks';

import rootReducer from './root-reducer'

const store = createStore(rootReducer, {}, applyMiddleware(taskMiddleware));

export default store;
